import { useCallback, useEffect, useMemo } from "react";

interface UseBlockVertScrollProps {
    resetScroll?: boolean;
    htmlElement: HTMLElement | null;
}

const useBlockVertScroll = ({ resetScroll, htmlElement }: UseBlockVertScrollProps) => {
    const unblockScroll = useCallback(() => {
        if (htmlElement) {
            htmlElement.style.overflowY = "auto";
            htmlElement.style.overflowX = "hidden";
        }
    }, [htmlElement]);

    const blockScroll = useCallback(() => {
        if (htmlElement) {
            htmlElement.style.overflowY = "hidden";
            htmlElement.style.overflowX = "hidden";
            if (resetScroll) {
                htmlElement.scrollTo(0, 0);
            }
        }
    }, [htmlElement, resetScroll]);

    useEffect(() => {
        blockScroll();
        return unblockScroll;
    }, [blockScroll, unblockScroll]);

    return useMemo(
        () => ({
            blockScroll,
            unblockScroll,
        }),
        [blockScroll, unblockScroll]
    );
};

export default useBlockVertScroll;
